import { render, staticRenderFns } from "./DocVideo.vue?vue&type=template&id=5feceafa&scoped=true&"
import script from "./DocVideo.vue?vue&type=script&lang=js&"
export * from "./DocVideo.vue?vue&type=script&lang=js&"
import style0 from "./DocVideo.vue?vue&type=style&index=0&id=5feceafa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feceafa",
  null
  
)

export default component.exports